import cvsu from "../assets/companies/cvsu.png";
import nbsc from "../assets/companies/nbsc.png";
import mati from "../assets/companies/mati.png";

export const education = [
  {
    id: "cvsu",
    evidenceNo: "BG-01",
    degree: "BS in Information Technology",
    university: "Cavite State University — Cavite City Campus",
    duration: "June 2018 — June 2023",
    status: "Graduated",
    primary: true,
    link: "https://cvsu.edu.ph/",
    logo: cvsu,
  },
  {
    id: "nbsc",
    evidenceNo: "BG-02",
    degree: "BS in Information Technology (coursework)",
    university: "Northern Bukidnon State College",
    duration: "June 2017 — May 2018",
    status: "Coursework",
    primary: false,
    link: "https://nbsc.edu.ph/",
    logo: nbsc,
  },
  {
    id: "mati",
    evidenceNo: "BG-03",
    degree: "BS in Business Administration (Office Management)",
    university: "Mindanao Arts and Technological Institute",
    duration: "August 2012 — January 2013",
    status: "Coursework",
    primary: false,
    link: "https://www.facebook.com/people/MATI-Mindanao-Arts-and-Technological-Institute/100064785904007/",
    logo: mati,
  },
];
